import { render, staticRenderFns } from "./CompanyUserPermissionList.vue?vue&type=template&id=211022f6&"
import script from "./CompanyUserPermissionList.vue?vue&type=script&lang=js&"
export * from "./CompanyUserPermissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports